var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { EnrollmentCommonService } from '../../../shared/services/enrollment-common.service';
import { CacheService } from '../../../shared/services/cache.service';
import { CustomerService } from '../../services/customer.service';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { OrderSourceValue } from '../../enums/order-source.enum';
import { AdyenPaymentService } from '../../services/adyen-payment.service';
// import AdyenCheckout from '@adyen/adyen-web/';
// import '@adyen/adyen-web/dist/adyen.css';
// import * as AdyenCheckout from '@adyen/adyen-web/dist/adyen.js';
import { AdyenPaymentMethodType } from '../../enums/adyen-payment-method-type.eum';
import { AdyenPaymentComponentSettings } from '../../models/payments/adyen-payment.model';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PaymentMethodTypes } from '../../enums/order-source-type';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
var AdyenPaymentComponent = /** @class */ (function () {
    function AdyenPaymentComponent(_customerService, _adyenPaymentService, _cacheService, _enrollmentCommonService) {
        this._customerService = _customerService;
        this._adyenPaymentService = _adyenPaymentService;
        this._cacheService = _cacheService;
        this._enrollmentCommonService = _enrollmentCommonService;
        this.states = [];
    }
    AdyenPaymentComponent.prototype.ngOnInit = function () {
        this.getStates();
        this.languageCode = this._cacheService.get(CacheKey.Language);
    };
    AdyenPaymentComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
                _this.loadAdyenPayments();
            }
            else {
                _this.loadAdyenPayments();
            }
        }, function (error) {
            _this.loadAdyenPayments();
        });
    };
    AdyenPaymentComponent.prototype.loadAdyenPayments = function () {
        var _this = this;
        if (this.adyenPaymentComponentSettings) {
            var paymentRequest = {
                countryCode: this.adyenPaymentComponentSettings.isoTwoletterCountryCode,
                currency: this.adyenPaymentComponentSettings.currencyCode ? this.adyenPaymentComponentSettings.currencyCode : '',
                countryCodeThree: this.adyenPaymentComponentSettings.isoCountryCode,
                orderSource: OrderSourceValue.CUSTOMER,
                orderTypeId: this._enrollmentCommonService.getAdyenOrderTypeId(this.orderType),
                orderReferenceId: this.adyenPaymentComponentSettings.orderReferenceId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.orderReferenceId : null,
                webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                storeId: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                memberId: this.adyenPaymentComponentSettings.memberId
                    ? +this.adyenPaymentComponentSettings.memberId : null,
                distributorId: this.adyenPaymentComponentSettings.distributorId
                    ? this.adyenPaymentComponentSettings.distributorId : null,
                uniqueRefID: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                    (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid ? this.sessionGuid : null)),
                shopperLocale: this.languageCode ? this.languageCode : null
            };
            this._adyenPaymentService.getAdyenPaymentForm(paymentRequest).subscribe(function (res) {
                if (_this.adyenPaymentComponentSettings.paymentMethodTypeForm) {
                    _this.adyenPaymentComponentSettings.paymentMethodTypeForm.enable();
                }
                // this.adyenPaymentConfig(res);
            }, function (error) {
                if (_this.adyenPaymentComponentSettings.paymentMethodTypeForm) {
                    _this.adyenPaymentComponentSettings.paymentMethodTypeForm.enable();
                }
            });
        }
    };
    // adyenPaymentConfig(res: any) {
    // const configuration = this.getConfigurationObj(res);
    // const checkout = new AdyenCheckout(configuration).create('dropin').mount(this.hook.nativeElement);
    // }
    AdyenPaymentComponent.prototype.getConfigurationObj = function (res) {
        var _this = this;
        var billingAddress = this.mapBillingAddress();
        var storePaymentConfig = res.storeMetaData;
        var paymentMethodResponse = res.paymentMethods;
        paymentMethodResponse.storedPaymentMethods = [];
        if (storePaymentConfig && storePaymentConfig.removeCreditCardBrands && storePaymentConfig.removeCreditCardBrands.length
            && res && res.paymentMethods && res.paymentMethods.paymentMethods) {
            var creditCardPaymentMethodIndex = res.paymentMethods.paymentMethods.findIndex(function (paymentMethod) { return paymentMethod.type == AdyenPaymentMethodType.scheme; });
            if (creditCardPaymentMethodIndex > -1 && res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex] && res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands) {
                res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands = res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands.filter(function (brand) { return !storePaymentConfig.removeCreditCardBrands.includes(brand); });
                var creditCardPaymentData = res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex];
                res.paymentMethods.paymentMethods.splice(creditCardPaymentMethodIndex, 1);
                res.paymentMethods.paymentMethods.splice(0, 0, creditCardPaymentData);
            }
        }
        var cardInfo = {};
        var configuration = {
            paymentMethodsResponse: paymentMethodResponse,
            clientKey: res.clientKey,
            locale: this.languageCode,
            environment: storePaymentConfig.environment,
            showPayButton: storePaymentConfig.showPayButton,
            origin: window.location.origin,
            paymentMethodsConfiguration: {
                card: {
                    shopperReference: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                        (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid ? this.sessionGuid : null)),
                    hasHolderName: storePaymentConfig.hasHolderName,
                    holderNameRequired: storePaymentConfig.holderNameRequired,
                    amount: {
                        value: res ? Math.round((res.amount + Number.EPSILON) * 100) : 0,
                        currency: this.adyenPaymentComponentSettings.store ?
                            this.adyenPaymentComponentSettings.store.currencyCode : '',
                    },
                    enableStoreDetails: this.adyenPaymentComponentSettings && (this.adyenPaymentComponentSettings.uniqueRefId || this.adyenPaymentComponentSettings.distributorId) ? storePaymentConfig.enableStoreDetails : false,
                    showStoredPaymentMethods: false,
                    billingAddressRequired: storePaymentConfig.billingAddressRequired,
                    data: {
                        billingAddress: {
                            street: billingAddress.street1,
                            postalCode: billingAddress.postcode,
                            city: billingAddress.city,
                            country: billingAddress.country,
                            stateOrProvince: billingAddress.state
                        }
                    },
                    onBrand: function (brandInfo, component) {
                        cardInfo.brand = brandInfo;
                    },
                    onFieldValid: function (state, component) {
                        if (state.fieldType === 'encryptedCardNumber') {
                            cardInfo.cardNumberInfo = state;
                        }
                    },
                },
            },
            onSubmit: function (state, component) {
                if (state.isValid && !_this.adyenPaymentComponentSettings.initiatePaymentInProgress) {
                    _this.adyenPaymentComponentSettings.initiatePaymentInProgress = true;
                    _this.initiatePayment(state, component, cardInfo);
                }
            },
            onAdditionalDetails: function (state, component) {
                _this.submitAdditionalDetails(state, component);
            },
        };
        return configuration;
    };
    AdyenPaymentComponent.prototype.mapBillingAddress = function () {
        var shippingAddress = this.adyenPaymentComponentSettings.billingAddress || this.adyenPaymentComponentSettings.shippingAddressDetail;
        var billingAddress = {
            street1: shippingAddress ? shippingAddress.addressLine1 : '',
            street2: shippingAddress ? shippingAddress.addressLine2 : '',
            city: shippingAddress ? shippingAddress.city : '',
            state: shippingAddress && shippingAddress.state ? shippingAddress.state : shippingAddress
                && shippingAddress.stateCode ? shippingAddress.stateCode : '',
            country: this.adyenPaymentComponentSettings.isoTwoletterCountryCode ? this.adyenPaymentComponentSettings.isoTwoletterCountryCode : '',
            postcode: shippingAddress ? shippingAddress.postalCode : ''
        };
        return billingAddress;
    };
    /**
       * @description  will trigger if onSubmit trigger from configuration object
       * @date 2021-06-02
       * @memberof AdyenPaymentComponent
       */
    AdyenPaymentComponent.prototype.initiatePayment = function (state, component, cardInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var initiateAdyenPaymentRequest_1;
            return __generator(this, function (_a) {
                try {
                    initiateAdyenPaymentRequest_1 = this.initiatePaymentRequest(state);
                    this._adyenPaymentService.initiatePayment(initiateAdyenPaymentRequest_1).subscribe(function (res) {
                        if (res.authorizeResponse.token) {
                            if (res.authorizeResponse && res.authorizeResponse) {
                                if (_this.sessionGuid) {
                                    _this._cacheService.set('PaymentInstrumentId', +res.authorizeResponse.token);
                                }
                                _this._cacheService.setSessionValue(CacheKey.SessionGuid, initiateAdyenPaymentRequest_1.uniqueRefID);
                            }
                        }
                        _this.adyenPaymentComponentSettings.initiatePaymentInProgress = false;
                        _this.handleServerResponse(res, component);
                    });
                }
                catch (error) {
                    this.adyenPaymentComponentSettings.initiatePaymentInProgress = false;
                    console.error(error);
                    alert('Error occurred. Look at console for details');
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @description  will trigger if submitAdditionalDetails trigger from configuration object
     * @date 2021-06-02
     * @private
     * @memberof AdyenPaymentComponent
     */
    AdyenPaymentComponent.prototype.submitAdditionalDetails = function (state, component) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var additionalRequest;
            return __generator(this, function (_a) {
                try {
                    additionalRequest = {
                        paymentMethodType: this.getPaymentMethodType(this.adyenPaymentComponentSettings.paymentMethodType),
                        orderSource: OrderSourceValue.CUSTOMER,
                        storeID: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                        webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                        paymentsDetailsRequest: state.data
                    };
                    this._adyenPaymentService.submitAdditionalDetails(additionalRequest).subscribe(function (res) {
                        _this.handleServerResponse(res, component);
                    });
                }
                catch (error) {
                    console.error(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
 * @description  returns InitiateAdyenPaymentRequest
 * @date 2021-06-02
 * @private
 * @memberof AdyenPaymentComponent
 */
    AdyenPaymentComponent.prototype.initiatePaymentRequest = function (state) {
        if (this.adyenPaymentComponentSettings) {
            this.adyenPaymentComponentSettings.paymentMethodType = state.data.paymentMethod.type;
            var paymentCallBackUrlModel = {
                cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
                failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
                successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
            };
            var amount = {
                currency: this.adyenPaymentComponentSettings.currencyCode ? this.adyenPaymentComponentSettings.currencyCode : '',
                value: this.adyenPaymentComponentSettings.amount ? this.adyenPaymentComponentSettings.amount : 0
            };
            var initiateAdyenPaymentRequest = {
                amount: amount,
                paymentRequest: state.data,
                countryCode: this.adyenPaymentComponentSettings.isoTwoletterCountryCode,
                storeID: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                orderSource: OrderSourceValue.CUSTOMER,
                orderTypeId: this._enrollmentCommonService.getAdyenOrderTypeId(this.orderType),
                orderReferenceId: this.adyenPaymentComponentSettings.orderReferenceId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.orderReferenceId : null,
                customerId: this.adyenPaymentComponentSettings.memberId ? (+this.adyenPaymentComponentSettings.memberId) : 0,
                distributorId: this.adyenPaymentComponentSettings.distributorId
                    ? this.adyenPaymentComponentSettings.distributorId : null,
                uniqueRefID: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                    (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid ? this.sessionGuid : null)),
                shopperEmail: this.adyenPaymentComponentSettings.memberEmail
                    ? this.adyenPaymentComponentSettings.memberEmail : null,
                paymentCallBackUrlModel: paymentCallBackUrlModel,
                paymentMethodType: this.getPaymentMethodType(state.data.paymentMethod.type)
            };
            return initiateAdyenPaymentRequest;
        }
    };
    /**
 * @description  redirect the page depends on resultCode
 * @date  2021-06-02
 * @memberof AdyenPaymentComponent
 */
    AdyenPaymentComponent.prototype.handleServerResponse = function (res, component) {
        var response = res.response ? res.response : res;
        var failureParams = '';
        if (response.refusalReasonCode && response.refusalReason) {
            failureParams = '?errorCode=' + response.refusalReasonCode + '&errorMessage=' + response.refusalReason;
        }
        if (response.action) {
            component.handleAction(response.action);
        }
        else {
            switch (response.resultCode) {
                case 'Authorised':
                    var routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
                    if (this.adyenPaymentComponentSettings.webOrderId && !window.location.href.includes('posorders')) {
                        routeURL = routeURL + this.adyenPaymentComponentSettings.webOrderId;
                    }
                    window.location.href = window.location.origin + routeURL;
                    break;
                case 'Pending':
                case 'Received':
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase();
                    break;
                case 'Refused':
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase() + failureParams;
                    break;
                default:
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase();
                    break;
            }
        }
    };
    /**
     * @description this method will return current window url
     * @date 2022-12-09
     * @private
     * @returns {string}
     * @memberof AdyenPaymentComponent
     */
    AdyenPaymentComponent.prototype.getCurrentWindowUrl = function () {
        var routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        if (this.adyenPaymentComponentSettings.webOrderId && !window.location.href.includes('posorders')) {
            routeURL = routeURL + this.adyenPaymentComponentSettings.webOrderId;
        }
        var currentWindowURL = window.location.origin + routeURL
            + PaymentProcessorAlias.ADYEN.toLowerCase() + '/';
        return currentWindowURL;
    };
    /**
     * @description  will return PaymentMethodType
     * @date 2022-12-09
     * @param paymentMethodType
     */
    AdyenPaymentComponent.prototype.getPaymentMethodType = function (paymentMethodType) {
        switch (paymentMethodType) {
            case AdyenPaymentMethodType.scheme:
                return PaymentMethodTypes.Credit_Card;
            case AdyenPaymentMethodType.swish:
                return PaymentMethodTypes.Swish;
            case AdyenPaymentMethodType.vipps:
                return PaymentMethodTypes.Vipps;
            case AdyenPaymentMethodType.trustly:
                return PaymentMethodTypes.Trustly;
            case AdyenPaymentMethodType.mobilepay:
                return PaymentMethodTypes.MobilePay;
            case AdyenPaymentMethodType.ideal:
                return PaymentMethodTypes.Ideal;
            case AdyenPaymentMethodType.bancontact_mistercash_and_maestro:
                return PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
            case AdyenPaymentMethodType.eps:
                return PaymentMethodTypes.Eps;
            case AdyenPaymentMethodType.giropay:
                return PaymentMethodTypes.Giro_Pay;
            case AdyenPaymentMethodType.blik:
                return PaymentMethodTypes.Blik;
            case AdyenPaymentMethodType.Walley:
                return PaymentMethodTypes.Walley;
            case AdyenPaymentMethodType.twint:
                return PaymentMethodTypes.Twint;
            case AdyenPaymentMethodType.riverty:
                return PaymentMethodTypes.Riverty;
            case AdyenPaymentMethodType.ApplePay_Adyen:
                return PaymentMethodTypes.ApplePay_Adyen;
            case AdyenPaymentMethodType.GooglePay_Adyen:
                return PaymentMethodTypes.GooglePay_Adyen;
            default:
                return PaymentMethodTypes.Credit_Card;
        }
    };
    return AdyenPaymentComponent;
}());
export { AdyenPaymentComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/adyen-payment.component.ts.pre-build-optimizer.js